import React, { useMemo, useState } from 'react';
import { Select as BaseSelect, Tag } from 'antd';
import './Select.less';
import classnames from 'classnames';
import { flatten, noop } from 'lodash';
import { defaultChoiceColor } from '../../utils';
import Highlighter from '../../../Highlighter';

export default function Select({
  onChange = noop,
  setFieldsValueChanged = noop,
  value,
  colorEnabled,
  choices,
  disabled,
  allowClear = true,
  showSearch = true,
  autoFocus,
  defaultOpen,
  onBlur,
  dropdownMatchSelectWidth,
  className,
  onDropdownVisibleChange,
  id,
  bordered,
  group,
  notFoundContent,
}) {
  const [searchValue, setSearchValue] = useState('');
  const innerChoices = useMemo(() => {
    const unExistChoices = [];
    let findUnExistChoices = choices || [];
    if (group) {
      findUnExistChoices = flatten(choices);
    }

    if (
      value &&
      !findUnExistChoices
        .filter((item) => item)
        .some((choice) => (choice.value || choice.text) === value)
    ) {
      unExistChoices.push({ text: value, value, color: defaultChoiceColor });
    }
    return []
      .concat(choices || [])
      .concat(unExistChoices)
      .filter((item) => item);
  }, [choices, value, group]);

  const renderOption = ({ text, value, color }) => {
    const mergedValue = value || text;
    if (!colorEnabled) {
      return (
        <BaseSelect.Option value={mergedValue} label={text}>
          <Highlighter searchValue={searchValue} text={text} />
        </BaseSelect.Option>
      );
    }
    return (
      <BaseSelect.Option value={mergedValue} label={text}>
        <Tag color={color || defaultChoiceColor} style={{ borderRadius: 11 }}>
          <Highlighter searchValue={searchValue} text={text} />
        </Tag>
      </BaseSelect.Option>
    );
  };

  const getValue = () => {
    if (!value) {
      return undefined;
    }
    const choice = flatten(innerChoices).find((item) => (item.value || item.text) === value);
    const color = choice?.color || defaultChoiceColor;
    if (colorEnabled) {
      const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
      // marginLeft保留光标位置
      return {
        value,
        label: (
          <Tag
            color={color}
            onMouseDown={onPreventMouseDown}
            style={{ marginLeft: 3, borderRadius: 11 }}
            closable
            onClose={() => {
              onChange(undefined);
              setFieldsValueChanged();
            }}
          >
            <span>{choice?.text || value}</span>
          </Tag>
        ),
      };
    }
    return { value, label: choice?.text || value };
  };

  return (
    <BaseSelect
      id={id}
      className={classnames('custom-field-select', { 'is-tag': colorEnabled }, className)}
      dropdownClassName="custom-field-select-dropdown"
      onChange={(value) => {
        onChange(value?.value);
        setFieldsValueChanged();
      }}
      value={getValue()}
      placeholder={'请选择'}
      allowClear={allowClear}
      disabled={disabled}
      showSearch={showSearch}
      searchValue={searchValue}
      onSearch={setSearchValue}
      autoClearSearchValue
      labelInValue
      autoFocus={autoFocus}
      defaultOpen={defaultOpen}
      onBlur={onBlur}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      onDropdownVisibleChange={onDropdownVisibleChange}
      bordered={bordered}
      optionFilterProp="label"
      notFoundContent={notFoundContent}
    >
      {innerChoices.map((choice) => {
        if (choice.children) {
          return (
            <BaseSelect.OptGroup label={choice.text}>
              {choice.children.map(renderOption)}
            </BaseSelect.OptGroup>
          );
        }
        return renderOption(choice);
      })}
    </BaseSelect>
  );
}
